import axios from 'axios'

const apiClient = axios.create({
  // baseURL: 'http://report.sir.my/api/',
  baseURL: 'http://60.48.136.18:6788/api/',
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default {
  request(url, parameter) {
    let para = JSON.stringify(parameter)
    return apiClient.post(url, para)
  },

  multipart(url, parameter, fileList) {
    let formData = new FormData()
    let para = JSON.stringify(parameter)
    formData.append('JsonData', para)
    for (var i = 0; i < fileList.length; i++) {
      formData.append('File', fileList[i].file)
    }
    return apiClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
